/* assets/planner-footer.js */
class PlannerFooter extends HTMLElement {
  connectedCallback() {
    // runs every time the cart-drawer footer is pulled in
    const dateI = this.querySelector('#delivery-day');
    const timeI = this.querySelector('#delivery-time');
    const cityI = this.querySelector('#choose-delivery-address');
    const btn = this.closest('form').querySelector('button[type="submit"]');

    console.log('planner-footer loaded');
    if (!dateI) return;

    const TIME_SLOTS = ['10:00 AM - 02:00 PM','02:00 PM - 08:00 PM'];

    const x = this;
    const minsNow = () => new Date().getHours()*60+new Date().getMinutes();
    const isToday = d => new Date().toDateString() === new Date(d).toDateString();
    
    // Set default date if no value exists
    const setDefaultDate = () => {
      if (!dateI.value.trim()) {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        dateI.value = tomorrow.toLocaleDateString('en-GB', options);
      }
    };

    function validate() {
      console.log('validate',dateI.value,timeI.value);
      btn && ([dateI,timeI].every(el=>el?.value.trim()) ? btn.disabled=false : btn.disabled=true);
      console.log('[dateI,timeI].every(el=>el?.value.trim(): ', [dateI,timeI].every(el=>el?.value.trim()));
      console.log('btn: ', btn);
    }

    function setSlots() {
      const day = new Date(dateI.value || new Date());
      console.log('setSlots',day);
      let slots = [...TIME_SLOTS];

      if (!isNaN(day) && isToday(day)) {
        if (minsNow() >= 730) slots = slots.slice(1);
        if (minsNow() >= 960) slots = [];
      }
      slots = slots.slice(0,2);
      console.log('slots: ', slots);
      timeI.replaceChildren(...slots.map(s=> new Option(s,s)))
      console.log('timeI: ', timeI);
      validate();
    }

    /* flatpickr loader (once per tag attach) */
    if (!window.flatpickr) {
      const s=document.createElement('script'); s.src='https://cdn.jsdelivr.net/npm/flatpickr'; s.onload=boot; x.parentNode.appendChild(s);
      const c=document.createElement('link');  c.rel='stylesheet'; c.href='https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css'; x.parentNode.appendChild(c);
    } else {boot();}

    function boot() {
      // Set default date first
      setDefaultDate();
      
      // Initialize flatpickr with better configuration
      const fp = flatpickr(dateI, {
        dateFormat: 'd M Y', 
        minDate: 'today', 
        maxDate: new Date().fp_incr(14), 
        onChange: setSlots,
        clickOpens: true,
        allowInput: false,
        defaultDate: dateI.value || null
      });
      
      // Ensure the input is clickable by adding event listener
      dateI.addEventListener('click', function() {
        fp.open();
      });
      
      // Make the input focusable but prevent manual typing
      dateI.addEventListener('focus', function() {
        fp.open();
      });
      
      [cityI,dateI,timeI].forEach(el=>el?.addEventListener('change', validate));
      setSlots(); 
      validate();
    }
  }
}
customElements.define('planner-footer', PlannerFooter);